import { render, staticRenderFns } from "./LeftAngleSvg.vue?vue&type=template&id=ce9bae2a&"
import script from "./LeftAngleSvg.vue?vue&type=script&lang=js&"
export * from "./LeftAngleSvg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports